import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import Registration from './pages/registration';
import Login from './pages/login';
import SecurityCenter from './pages/security-center';
import AccountDashboard from './pages/account-dashboard';
import TradingInterface from './pages/trading-interface';
import FundingPortal from './pages/funding-portal';
import Homepage from './pages/homepage';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider } from './contexts/AuthContext';

const Routes = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* Define your route here */}
          <Route path="/" element={<Homepage />} />
          <Route path="/registration" element={<Registration />} />
          <Route path="/login" element={<Login />} />
          <Route 
            path="/security-center" 
            element={
              <ProtectedRoute>
                <SecurityCenter />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/account-dashboard" 
            element={
              <ProtectedRoute>
                <AccountDashboard />
              </ProtectedRoute>
            } 
          />
          <Route path="/trading-interface" element={<TradingInterface />} />
          <Route path="/funding-portal" element={<FundingPortal />} />
          <Route path="/homepage" element={<Homepage />} />
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
        </ErrorBoundary>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;
